/* App-wide popups that any screen can open: the sign-up sheet, the Premium upsell. */
import { create } from 'zustand'

export const useOverlays = create<{ signup: { reason: string | null; mode: 'signup' | 'signin' } | null; premium: string | null }>(() => ({ signup: null, premium: null }))

export function openSignup(reason: string | null = null, mode: 'signup' | 'signin' = 'signup') {
  useOverlays.setState({ signup: { reason, mode } })
}
export function closeSignup() {
  useOverlays.setState({ signup: null })
}
export function openPremium(reason: string) {
  useOverlays.setState({ premium: reason })
}
export function closePremium() {
  useOverlays.setState({ premium: null })
}
